import { useSelector } from 'react-redux'
import { selectIsNoDelay } from '../../settings/settingsSlice.js'
import { selectIsNothingAvailableInFreePlay } from '../../storyPaths.js'
import TeaserModal from './TeaserModal.js'

// Free play's equivalent of GlobalCooldown: since there's no real-time wait to
// display a modal during, this instead opens once nothing is left to do in
// the current time-of-day slot, prompting the player to advance time.
export default function FreePlayTeaser () {
  const isFreePlay = useSelector(selectIsNoDelay)
  const isNothingAvailable = useSelector(selectIsNothingAvailableInFreePlay)
  return <TeaserModal isOpen={isFreePlay && isNothingAvailable} heading='Bel is busy, tap bottom right to advance time...' />
}
